import React from 'react';
import { format, parseISO } from 'date-fns';
import { ClockIcon, MapPinIcon, UsersIcon } from 'lucide-react';
import type { EventItem } from '../types/events';
type EventCardProps = {
  event: EventItem;
  index: number;
  past?: boolean;
};
const dateColors = ['bg-sunset text-ink', 'bg-catracho text-sand', 'bg-flamingo text-sand', 'bg-sun text-ink'];
export function EventCard({
  event,
  index,
  past = false
}: EventCardProps) {
  const d = parseISO(event.date);
  return <li className="flex w-[85%] shrink-0 snap-start flex-col overflow-hidden rounded-[1.75rem] bg-dune p-6 sm:w-[340px]" data-id="element-50" data-mp="1st2x0u8wma81">
      {event.image && <img src={event.image} alt={event.imageAlt ?? ''} className="-mx-6 -mt-6 mb-6 aspect-[16/10] w-[calc(100%+3rem)] max-w-none object-cover" data-id="element-51" data-mp="27ja5qi940evj" />}
      <div className="flex items-start justify-between gap-4" data-id="element-52" data-mp="1f03h4r57mdzy">
        <div className={`flex w-20 flex-col items-center rounded-2xl py-3 ${past ? 'bg-ink text-sand' : dateColors[index % dateColors.length]}`} data-id="element-53" data-mp="1a2l9r56uc6u2">
          <span className="text-xs font-bold uppercase tracking-wider" data-id="element-54" data-mp="3cn073nb1v3dq">{format(d, 'MMM')}</span>
          <span className="font-display text-4xl leading-none" data-id="element-55" data-mp="3hdynemw1g1gz">{format(d, 'd')}</span>
          <span className="mt-0.5 text-xs font-bold" data-id="element-56" data-mp="3hgck106d9lqn">{format(d, past ? 'yyyy' : 'EEE')}</span>
        </div>
        <div className="flex flex-col items-end gap-2" data-id="element-57" data-mp="2opazejjwmxzq">
          <span className="rounded-full bg-sand px-3 py-1 text-xs font-bold text-ink/70" data-id="element-58" data-mp="2oqvtk82b4ex2">{event.tag}</span>
          {event.price && <span className="whitespace-nowrap rounded-full bg-catracho px-3 py-1 text-xs font-bold text-sand" data-id="element-59" data-mp="2tq8olg3c0saq">
              {event.price}
            </span>}
        </div>
      </div>

      <h3 className="mt-6 font-display text-2xl uppercase leading-tight text-ink" data-id="element-60" data-mp="32mptw2p0lvyk">{event.title}</h3>
      {event.subtitle && <p className="mt-1 font-script text-2xl text-flamingo" data-id="element-61" data-mp="hylb5jq9y15u">{event.subtitle}</p>}
      {event.description && <p className="mt-3 text-sm leading-relaxed text-ink/80" data-id="element-62" data-mp="2e1q3d1l7klgx">{event.description}</p>}
      {event.descriptionEs && <p lang="es" className="mt-2 text-sm italic leading-relaxed text-ink/60" data-id="element-63" data-mp="29zcuw5f2u9gg">
          {event.descriptionEs}
        </p>}

      <dl className="mt-4 space-y-2 text-sm text-ink/75" data-id="element-64" data-mp="2nze6ofwvr1ap">
        {event.time && <div className="flex items-center gap-2" data-id="element-65" data-mp="2j1m5evaci2tu">
            <dt className="sr-only" data-id="element-66" data-mp="1vb8jznm9n288">Time</dt>
            <ClockIcon size={16} className="shrink-0 text-ink/50" aria-hidden="true" data-id="element-67" data-mp="1vc1jq4mt4rgv" />
            <dd data-id="element-68" data-mp="1qdqanw4c6kzp">{event.time}</dd>
          </div>}
        <div className="flex items-center gap-2" data-id="element-69" data-mp="251bfpvkruua9">
          <dt className="sr-only" data-id="element-70" data-mp="252w7jdfpbz4f">Location</dt>
          <MapPinIcon size={16} className="shrink-0 text-ink/50" aria-hidden="true" data-id="element-71" data-mp="20al4w2tktz86" />
          <dd data-id="element-72" data-mp="208rxglb53az4">{event.location}</dd>
        </div>
      </dl>

      {past && event.attended && <div className="mt-auto flex items-end gap-2 border-t border-ink/10 pt-5" data-id="element-73" data-mp="1cinveidlnja8">
          <UsersIcon size={20} className="mb-1 text-flamingo" aria-hidden="true" data-id="element-74" data-mp="17lnroe482sma" />
          <span className="font-display text-4xl leading-none text-ink" data-id="element-75" data-mp="3j7pwxes74ot7">{event.attended}</span>
          <span className="pb-0.5 text-sm font-bold text-ink/70" data-id="element-76" data-mp="3o0rejujsf2gh">attended</span>
        </div>}
    </li>;
}